<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2025-11-17 11:29:30
-->
<template>
  <div>
    <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">联系我们</div>
      </div>
    </div> -->
    <div class="content">
      <!-- <div v-for="(item, index) in datalist" :key="index"> -->
      <div>
        <!-- <div class="name" :class="{ smallname: index > 0 }" v-if="index == 0">
          {{ item.title }}
        </div> -->
        <div class="name">河北宏信招标有限公司</div>
        <ul class="infodiv">
          <li v-for="(data, i) in datalist" :key="i">
            <div>
              <i class="el-icon-phone"></i>
              <span>{{ data.name }}：{{ data.tel }}</span>
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="name">招标部</div>
      <ul class="infodiv">
        <li>
          <div>
            <i class="el-icon-phone-outline"></i>
            <span>公司总机：010-63905999</span>
          </div>
        </li>
      </ul> -->
      <div id="map">
        <img src="@/assets/images/hzgcsmall.png" />
      </div>
    </div>
  </div>
</template>
<script>
// import BMap from "BMap";
export default {
  data() {
    return {
      activeName: "1",
      datalist: []
    };
  },
  mounted() {
    this.getinfo();
    // var map = new BMap.Map("map");
    // let point = new BMap.Point(114.468839, 38.059148);
    // map.centerAndZoom(point, 20);
    // map.enableScrollWheelZoom(true);
    // var marker = new BMap.Marker(point); // 创建标注
    // map.addOverlay(marker);
  },
  methods: {
    getinfo() {
      this.$get("/website/hxcontactus/list").then(res => {
        this.datalist = res.data;
      });
    }
  }
};
</script>
<style scoped>
#map {
  width: 100%;
  height: 400px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  background: #eee;
  border: 5px solid #fff;
  box-sizing: border-box;
  margin-top: 19px;
}
#map img { height: 100%;width: 100%;}
.name {
  font-size: 28px;
  padding: 10px 0 30px 0;
  font-weight: bold;
}
.content {
  width: 1160px;
  margin: 0 auto;
  padding: 20px;
  float: none;
  background: #f5fafe;
  margin-top: 20px;
}
.infodiv {
  background: #fff;
  overflow: hidden;
  /* margin-bottom: 20px; */
  padding-bottom: 1px;
}
.infodiv li {
  float: left;
  height: 60px;
  width: 50%;
  line-height: 60px;
}
.infodiv li > div {
  overflow: hidden;
  margin: 0 15px;
  border-bottom: 1px solid #ddd;
}
.infodiv li i,
.infodiv li span {
  color: rgb(49, 58, 87);
  display: inline-block;
  float: left;
}
.infodiv li i {
  font-size: 24px;
  margin-top: 18px;
  padding-right: 15px;
}
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}

.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
/* .name.smallname {
  font-weight: normal;
} */
</style>
